import { render, staticRenderFns } from "./diaClient.vue?vue&type=template&id=042a0782"
import script from "./diaClient.vue?vue&type=script&lang=js"
export * from "./diaClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports